import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  Agenda_Table_data: {
    columns: [
      {
        label: 'Index',
        field: 'Index',
        sort: 'asc'
      },
      {
        label: 'Title',
        field: 'title',
        sort: 'asc'
      },
      {
        label: 'Start Time',
        field: 'Start_Date',
        sort: 'asc'
      },
      {
        label: 'End Time',
        field: 'End_Date',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ]
  },
  Event_Public_Speaker_Table_data: {
    columns: [
      {
        label: 'Full Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'LinkedIn Profile URL',
        field: 'LinkedIn_Profile_URL',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
  },
  // EventOrganizerData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_RECEPTION:
      return {
        ...state,
        // receptionData: action.value
      };
    default:
      return state;
  }
};

export default reducer;
